import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.flat-map.js";
import { defineComponent as _defineComponent } from 'vue';
import variables from '@vab/styles/variables/variables.module.scss';
import { useRoutesStore } from '@/store/modules/routes';
import { useSettingsStore } from '@/store/modules/settings';
import { defaultOpeneds, uniqueOpened } from '@/config';

import { storeToRefs } from 'pinia';
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    layout: {
      type: String,
      default: 'vertical'
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const props = __props;
    const settingsStore = useSettingsStore();
    const {
      collapse
    } = storeToRefs(settingsStore);
    const routesStore = useRoutesStore();
    const {
      getRoutes: routes,
      getActiveMenu: activeMenu,
      getPartialRoutes: partialRoutes
    } = storeToRefs(routesStore);
    const handleRoutes = computed(() => {
      return props.layout === 'comprehensive' ? partialRoutes.value : routes.value.flatMap(route => route.meta.levelHidden && route.children ? [...route.children] : route);
    });
    const __returned__ = {
      props,
      settingsStore,
      collapse,
      routesStore,
      routes,
      activeMenu,
      partialRoutes,
      handleRoutes,
      get variables() {
        return variables;
      },
      get defaultOpeneds() {
        return defaultOpeneds;
      },
      get uniqueOpened() {
        return uniqueOpened;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});